import clone from 'lodash/cloneDeep';
import initialState from '../../store/initialState';
import {
    ADD_TOWER_COMPANY_STARTING,
    ADD_TOWER_COMPANY_SUCCESS,
    ADD_TOWER_COMPANY_ERROR,
} from '../../constants/actionTypes';

export default function addTowerCompanyReducer(state = initialState.addTowerCompany, action) {
    switch (action.type) {
        case ADD_TOWER_COMPANY_STARTING: {
            const newState = clone(state);
            newState.saving = true;
            newState.saved = false;
            return newState;
        }
        case ADD_TOWER_COMPANY_SUCCESS: {
            const newState = clone(state);
            newState.saving = false;
            newState.saved = true;
            newState.error = null;
            return newState;
        }

        case ADD_TOWER_COMPANY_ERROR: {
            const newState = clone(state);
            newState.saving = false;
            newState.saved = false;
            newState.error = action.err;
            return newState;
        }

        default: {
            return state;
        }
    }
}